import {isFeatureEnabled} from 'feature-flags';
import {Box, Show, Stack} from 'platform/foundation';

import {defaultTo} from 'ramda';

import {useGetUserDashboardSettingsQuery} from '@dms/api/customer';
import {featureFlags} from '@dms/feature-flags';
import {testIds} from '@dms/routes';
import {usePermissions} from '@dms/shared';
import {TaskCenterCard} from '@dms/task-manager';

import {MyNotifications} from './MyNotifications';

const defaultToFalse = defaultTo(false);

export function TasksAndNotifications() {
  const {data: userDashboardSettings} = useGetUserDashboardSettingsQuery();

  const [canReadTasks] = usePermissions({
    permissionKeys: ['readTask'],
  });

  return (
    <Stack width="100%" spacing={4} justify="stretch" direction={['column', 'column', 'row']}>
      <Show
        when={
          isFeatureEnabled(featureFlags.CORE_TASK_MANAGEMENT) &&
          canReadTasks &&
          defaultToFalse(userDashboardSettings?.myTasks)
        }
      >
        <Box width={['100%', undefined]} flexGrow={[undefined, 1]}>
          <TaskCenterCard data-testid={testIds.dashboard.home('tasks')} />
        </Box>
      </Show>
      <Show when={defaultToFalse(userDashboardSettings?.notifications)}>
        <Box
          width={['100%', undefined]}
          flexGrow={[undefined, 1]}
          maxWidth={[undefined, undefined, '50%']}
        >
          <MyNotifications />
        </Box>
      </Show>
    </Stack>
  );
}
